<template>
   <form @submit.prevent>
      <CModal
         :title.sync="title"
         color="info"
         :closeOnBackdrop="false"
         :show.sync="show"
      >
         <label> Graduate participant from this class ? </label>
         <template #footer>
            <CButton
               style="width:200px"
               color="success"
               block
               v-on:click.prevent="setGraduate()"
               type="submit"
               >Graduate</CButton
            >
            <CButton @click="show = false" color="danger">Close</CButton>
         </template>
         <!-- <pre>{{ $data | json }}</pre> -->
      </CModal>
   </form>
</template>

<script>
import EventBus from "@/eventBus";
import classparticipant from "@/services/class_schedule";

export default {
   name: "peoplemodal",

   data() {
      return {
         show: false,
         title: "Default Title",
         mode: "",
         form: {
            id: "",
            id_list_graduate: "",
         },
         fields: [
            { title: "Batch Name", sortable: false },
            { title: "Template Name", sortable: false },
            { title: "Class Date", sortable: false },
            { title: "Attend", sortable: false },
            { title: "Attend Date", sortable: false },
         ],
      };
   },
   computed: {},
   mounted() {},
   created() {
      var self = this;
      EventBus.$on("OPEN_SHOW_GRADUATE", (params) => {
         if (params.data) {
            classparticipant
               .getParticipantbyID(params.data)
               .then((res) => {
                  this.datas = res;
                  self.show = true;
                  self.title = params.title;
                  self.mode = params.mode;
                  self.form.uuid = params.data;
               })
               .catch((err) => {
                  var params = {
                     title: "Error",
                     mode: "danger",
                     data: err.response.data.message,
                  };
                  EventBus.$emit("OPEN_MODAL_ALERT", params);
               });
         } else {
            self.show = true;
            self.title = params.title;
            self.mode = params.mode;
            self.form.uuid = "";
         }
      });
   },

   methods: {
      open() {
         this.show = true;
      },
      close() {
         this.show = false;
      },
      setGraduate() {
         this.show = false;
         classparticipant
            .setGraduate({
               id_list_graduate: this.form.uuid,
            })
            .then((res) => {
               var params = {
                  title: "Success",
                  mode: "success",
                  data: res.message,
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
            })
            .catch((err) => {
               var params = {
                  title: "Error",
                  mode: "danger",
                  data: err.response.data.message,
               };
               EventBus.$emit("OPEN_MODAL_ALERT", params);
            });
      },
   },
};
</script>
